import React, { Component } from 'react'
import RecentPost from './recentpost'
import NewCommentForm from "./newcommentform";
import NewComment from './newcomment'
import GridPost from './gridpost'
import { Carousel, Row, Col, Icon, Card, Avatar, Button, List, Input, Pagination, notification } from 'antd';
const openNotificationWithIcon = (type, message) => {
  notification[type]({
    message: 'Notification',
    description: message,
  });
};

class OurPost extends Component {
  constructor(props) {
    super(props)
    this.state = {
      comments: [],
      searchInput: '',
      searchResults: [],
      showSearch: false,
      searchLoading: false,
      showCatPosts: false,
      showCatPostsSlug: 'continuereading',
      catPosts: [],
      shoowCatPostsLoading: false,
      sortedPosts: []
    }
  }

  loadCatPosts = (e, slug) => {
    e.preventDefault()
    if (slug === 'continuereading') {
      this.setState({
        showCatPosts: false,
        showCatPostsSlug: slug,
        showSearch: false,
        catPosts: [],
        shoowCatPostsLoading: false,
        searchInput: ''
      })
    } else {
      this.setState({
        showCatPosts: true,
        showCatPostsSlug: slug,
        showSearch: false,
        catPosts: [],
        shoowCatPostsLoading: true,
        searchInput: ''
      })
      this.props.getCatPosts(slug)
    }
  }

  componentDidMount() {
    this.setState({
      comments: this.props.comments
    })
  }

  componentWillReceiveProps(nextProps) {
    const { comments, catPosts, posts } = nextProps
    if (comments.length > 0) {
      const sortedComments = comments.sort((a, b) => new Date(a.created) - new Date(b.created))
      this.setState({
        comments: sortedComments
      })
    }
    if(posts.length > 0) {
      const sortedPosts = posts.sort((a, b) => new Date(b.created) - new Date(a.created))
      this.setState({
        sortedPosts
      })
    }
    this.setState({
      catPosts,
      shoowCatPostsLoading: false
    })
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  searchPosts = (e) => {
    e.preventDefault()
    const { posts } = this.props
    const { searchInput } = this.state
    this.setState({
      showSearch: true,
      showCatPosts: false,
      showCatPostsSlug: ''
    })
    this.setState({
      searchLoading: true
    })
    setTimeout(() => {
      this.setState({
        searchLoading: false
      })
    }, 700);
    if (searchInput.trim().length) {
      let results = posts.filter(post => post.content.toLowerCase().includes(searchInput.trim().toLowerCase()) || post.title.toLowerCase().includes(searchInput.trim().toLowerCase()))
      this.setState({
        searchResults: results
      })
    } else {
      this.setState({
        searchResults: [],
        showSearch: false,
        showCatPosts: false,
      })
      openNotificationWithIcon('warning', 'You can not make an empty search')
    }
  }

  render() {
    const { posts, postcats, post } = this.props
    const { comments, searchInput, showSearch, searchLoading, searchResults, showCatPosts, catPosts, shoowCatPostsLoading, showCatPostsSlug, sortedPosts } = this.state
    return (
      <div className="our-blog blog-innner-page blog-list blog-details">
        <div className="container">
          <div className="mobile-search">
            <form action="#" className="sidebar-search">
              <input type="text" placeholder="Search" name="searchInput" onChange={(e) => this.handleChange(e)} value={searchInput} />
              <button className="tran3s" onClick={(e) => this.searchPosts(e)}><i className="flaticon-search"></i></button>
            </form>
          </div>
          <div className="row">
            {
              !showSearch && !showCatPosts ? <div className="col-md-8 col-xs-12">
                <div className="single-blog">
                  <div className="image"><img src={post.image} alt={post.slug} /></div>
                  <ul>
                    <li>
                      <i className="flaticon-comments"></i>
                      <a href="#" className="tran3s">{comments.length}</a>
                    </li>
                    <li>
                      <i className="flaticon-heart"></i>
                      <a href="#" className="tran3s">{post.likes}</a>
                    </li>
                  </ul>
                  <h4>{post.title}</h4>
                  <p dangerouslySetInnerHTML={{ __html: post.content }}></p>

                </div>
                <div className="comment-area">
                  <div className="comment-title clearfix">
                    <h4 className="float-left">Comments <span className="s-bg-color">{comments.length}</span></h4>
                  </div>
                  {
                    comments.map((comment) => (
                      <NewComment key={comment.id} commentDetail={comment} sendReplyComment={this.props.sendReplyComment} profile={this.props.profile} postId={this.props.postId} likeComment={this.props.likeComment} unLikeComment={this.props.unLikeComment} likeSubComment={this.props.likeSubComment} unLikeSubComment={this.props.unLikeSubComment} />
                    ))
                  }
                </div>
                <NewCommentForm profile={this.props.profile} postId={this.props.postId} sendComment={this.props.sendComment} />
              </div> : null
            }
            {
              showSearch ? <div className="col-md-8 col-xs-12">
                {
                  searchLoading ? <div className="loading-holder">
                    <Icon type="loading" style={{ fontSize: 60 }} spin />
                  </div> :
                    <div>
                      {
                        searchResults.length ? <div>
                          <h4 className="x-result-title">Search Results for <i>{searchInput}</i></h4>
                          <div className="row">
                            {
                              searchResults.map((post) => (
                                <GridPost key={post.id} detail={post} />
                              ))
                            }
                          </div>
                        </div> : <h4 className="x-result-title">No results found for <i>{searchInput}</i></h4>
                      }
                    </div>
                }
              </div> : null
            }
            {
              showCatPosts ?
                shoowCatPostsLoading ? <div className="col-md-8 col-xs-12"> <div className="loading-holder">
                  <Icon type="loading" style={{ fontSize: 60 }} spin />
                </div> </div> : <div className="col-md-8 col-xs-12">
                    {
                      catPosts.length === 0 ? <h4 className="x-result-title">There are no posts under <i>{showCatPostsSlug}</i></h4> : <h4 className="x-result-title">Posts under <i>{showCatPostsSlug}</i></h4>
                    }
                    <div className="row">
                      {
                        catPosts.map((post) => (
                          <GridPost key={post.id} detail={post} />
                        ))
                      }
                    </div>
                  </div> : null
            }
            <div className="col-md-4 col-sm-6 col-xs-12 theme-sidebar">
              <form action="#" className="sidebar-search desktop-search">
                <input type="text" placeholder="Search" name="searchInput" onChange={(e) => this.handleChange(e)} value={searchInput} />
                <button className="tran3s" onClick={(e) => this.searchPosts(e)}><i className="flaticon-search"></i></button>
              </form>
              <div className="sidebar-keyword">
                <h4>Categories</h4>
                <ul className="clearfix">
                  <li><a href="#" className={`tran3s ${'continuereading' === showCatPostsSlug ? 'active' : null}`} onClick={(e) => this.loadCatPosts(e, 'continuereading')}>Continue Reading</a></li>
                  {
                    postcats.map((postcat) => (
                      <li key={postcat.id}><a href="#" className={`tran3s ${postcat.slug === showCatPostsSlug ? 'active' : null}`} onClick={(e) => this.loadCatPosts(e, postcat.slug)}>{postcat.name}</a></li>
                    ))
                  }
                </ul>
              </div>
              <div className="sidebar-recent-news">
                <h4>Recent News</h4>
                <ul>
                  {
                    sortedPosts.slice(0, 4).map((rpost) => (
                      <RecentPost key={rpost.id} detail={rpost} />
                    ))
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default OurPost